export const submitChecklistAnswerOptions = {
  props: ({mutate}) => ({
    submitChecklistAnswerMutation: variables => {
      return mutate({
        variables,
        refetchQueries: []
      });
    }
  })
};

export const escalateCheckOptions = {
  props: ({mutate}) => ({
    escalateCheckMutation: variables => {
      return mutate({
        variables,
        refetchQueries: []
      });
    }
  })
};
